export const DASHBOARD_LINE_CHART_GRID = {
    top: 16,
    right: 12,
    bottom: 8,
    left: 8,
    outerBounds: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
};

export const DASHBOARD_LINE_CHART_TOOLTIP = {
    trigger: "axis",
};

export const DASHBOARD_LINE_CHART_X_AXIS = {
    type: "category",
    boundaryGap: false,
    axisLabel: {color: "#AAAAAA"},
    axisLine: {lineStyle: {color: "#404B63"}},
    axisTick: {show: false},
};

export const DASHBOARD_LINE_CHART_Y_AXIS = {
    type: "value",
    minInterval: 1,
    axisLabel: {color: "#AAAAAA"},
    axisLine: {show: true, lineStyle: {color: "#404B63"}},
    splitLine: {
        lineStyle: {
            color: "#3a3a3a",
        },
    },
};

export const DASHBOARD_LINE_SERIES_STYLE = {
    type: "line",
    showSymbol: false,
    smooth: true,
    lineStyle: {
        width: 3,
        color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
                {offset: 0, color: "#0080ED"},
                {offset: 0.5, color: "#3E98D9"},
                {offset: 1, color: "#1CEAE6"},
            ],
        },
    },
    itemStyle: {
        color: "#1CEAE6",
    },
    areaStyle: {
        opacity: 1,
        color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
                {offset: 0, color: "rgba(28, 234, 230, 0.65)"},
                {offset: 0.42, color: "rgba(62, 152, 217, 0.48)"},
                {offset: 0.7, color: "rgba(0, 128, 237, 0.32)"},
                {offset: 1, color: "rgba(0, 56, 120, 0)"},
            ],
        },
    },
};

export const DASHBOARD_LAST_POINT_SERIES_STYLE = {
    type: "effectScatter",
    symbolSize: 9,
    z: 10,
    itemStyle: {
        color: "#00C8FF",
    },
    rippleEffect: {
        scale: 3,
        period: 2,
        brushType: "stroke",
    },
    tooltip: {
        show: false,
    },
};
